import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const DivContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  backgroundColor: '#FFFFFF',
  border: '1px solid #EAEAEA',
  borderRadius: '10px',
  height: 'fit-content',
  width: '336px',
});

const TextContainer = styled('div')({
  padding: '12px 15px',
});

const HelloTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontSize: '36px',
  lineHeight: '54px',
  letterSpacing: '0.15px',
  fontWeight: 500,
  color: '#414046',
});

const SubtitleTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.15px',
  fontWeight: 500,
});

const DrawerMenuDivider = styled('hr')({
  class: 'solid',
  width: '99.9%',
  border: '0.5px solid #EAEAEA',
  margin: '0px',
});

const LoginButton = styled('button')({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.16px',
  color: '#0A7ABE',
  textTransform: 'none',
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  padding: '10px',
  margin: '0px',
  justifyContent: 'center',
  alignItems: 'center',
});

export {
  DivContainer,
  TextContainer,
  HelloTypography,
  SubtitleTypography,
  DrawerMenuDivider,
  LoginButton,
};
